import type { ComponentProps } from "react";
import Spinner from "../../DesignSystem/Spinner";
import RoundedContainer from "./RoundedContainer";
import Header from "./Header";

// Shared loading state for full pages inside the app shell. Renders the same frame a loaded page
// shows — the real <Header /> (so its global right cluster appears during load) above a
// RoundedContainer (the rounded card) — with a page spinner where the content will go, so the card
// doesn't pop in or shift on load. Header props are forwarded so each caller supplies its own
// breadcrumb: ContentFallback derives it from the URL (chunk loads); entity pages pass a normal
// breadcrumbs array with a { loading: true } leaf crumb (see Header's Breadcrumb) while data loads.
type PageLoadingStateProps = Pick<ComponentProps<typeof Header>, "iconKey" | "left" | "breadcrumbs" | "hideNav">;

export default function PageLoadingState(props: PageLoadingStateProps) {
    return (
        <>
            <Header {...props} />
            <LoadingCard />
        </>
    );
}

// Just the card portion — a RoundedContainer with a centered page spinner, no header. Use this on
// its own as a Suspense fallback under a page that already renders its own Header (e.g. RFQ wraps
// its <Outlet /> in it), so a sub-route's chunk load shows a spinner under the persistent header
// instead of bubbling up to a parent fallback that would tear the header down.
export function LoadingCard() {
    return (
        <RoundedContainer>
            <div className="flex h-full items-center justify-center">
                <Spinner variant="page" />
            </div>
        </RoundedContainer>
    );
}
